import styled from '@emotion/styled';

export const TeamSettingsActivityLibraryStyled = styled('div')`
	padding: 1rem 2rem;
`;
